import { loadWASM } from "onigasm";
import configs from "./configs";
import ReactDOM from "react-dom";
import React from "react";
import * as Sentry from "@sentry/browser";
import "abortcontroller-polyfill/dist/polyfill-patch-fetch";
import "./ui/fluent/fonts.css";
import App from "./ui/App";
import Api from "./api/Api";
import { initTelemetry } from "./telemetry";
import BrandingThemeProvider from "./ui/BrandingThemeProvider.js";

export const fontFaces = [
  {
    name: "Segoe UI",
    paths: [
      "https://res-1.cdn.office.net/files/fabric-cdn-prod_20221209.001/assets/fonts/segoeui-westeuropean/segoeui-regular.woff2"
    ],
    props: { fontWeight: 400 }
  },
  {
    name: "Segoe UI",
    paths: [
      "https://res-1.cdn.office.net/files/fabric-cdn-prod_20221209.001/assets/fonts/segoeui-westeuropean/segoeui-semibold.woff2"
    ],
    props: { fontWeight: 600 }
  },
  {
    name: "Segoe UI",
    paths: [
      "https://res-1.cdn.office.net/files/fabric-cdn-prod_20221209.001/assets/fonts/segoeui-westeuropean/segoeui-bold.woff2"
    ],
    props: { fontWeight: 700 }
  }
];

if (configs.SENTRY_DSN) {
  Sentry.init({
    dsn: configs.SENTRY_DSN,
    release: process.env.BUILD_VERSION,
    integrations(integrations) {
      return integrations.filter(integration => integration.name !== "Breadcrumbs");
    }
  });
}

initTelemetry();

const api = new Api();

(async () => {
  try {
    //TODO: Check if is possible to make a local import of the wasm file
    const response = await fetch("https://mudfoundation.blob.core.windows.net/nrd/aux/monaco/onigasm.wasm");
    const wasmBinary = await response.arrayBuffer();
    await loadWASM(wasmBinary);
  } catch (e) {
    console.error("Failed to load WASM file:", e);
  }

  ReactDOM.render(
    <BrandingThemeProvider api={api}>
      <App api={api} />
      <div id="portal-root" style={{ position: "relative", zIndex: 10000000 }} />
    </BrandingThemeProvider>,
    document.getElementById("app")
  );
})();

// Hot Module Replacement (HMR) - Accept self
if (module.hot) {
  module.hot.accept();
}
